import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import BookSeat from '@/pages/seat-booking/BookSeat';
import BookingList from '@/pages/seat-booking/BookingList';
import BookingReport from '@/pages/seat-booking/BookingReport';
import BookingAmountSet from '@/pages/seat-booking/BookingAmountSet';
import ConvertToAdmission from '@/pages/seat-booking/ConvertToAdmission';

export const seatBookingRoutes = (
  <React.Fragment>
    <Route path="seat-booking" element={<Navigate to="seat-booking/list" replace />} />
    <Route path="seat-booking/book" element={<BookSeat />} />
    <Route path="seat-booking/list" element={<BookingList />} />
    <Route path="seat-booking/report" element={<BookingReport />} />
    <Route path="seat-booking/amount-set" element={<BookingAmountSet />} />
    <Route path="seat-booking/amount-settings" element={<BookingAmountSet />} />
    <Route path="seat-booking/convert" element={<ConvertToAdmission />} />
  </React.Fragment>
);
